import {
  FetchParams,
  Middleware,
  RequestContext,
} from '@neptune/shared/core-apis-middleware-domain';
import { updateAndAppendAuthTokenToHeaders } from '@neptune/shared/core-auth-domain';

export const updateTokenMiddleware: Middleware = {
  async pre(context: RequestContext): Promise<FetchParams | void> {
    const headers = await updateAndAppendAuthTokenToHeaders(context.init.headers, {
      url: context.url,
    });

    return {
      ...context,
      init: {
        ...context.init,
        headers,
      },
    };
  },
};
